import { AdProviderBase } from './AdProviderBase';

//https://developers.facebook.com/docs/games/instant-games/guides/ads-monetization
export default class AdProvider_Facebook extends AdProviderBase {
	constructor(options) {
		super(options);

		this.preloadedInterstitial = null;

		this._isAdLoading = false;
		this._isAdLoaded = false;
		this._errorCount = 0;
		this._errorCountMax = 6;

	}

	setup() {
		console.log('FB_Ads.setup');

		if (typeof FBInstant === 'undefined' || !globalThis.FBInstant) {
			console.log('FBInstant plugin not ready'); return false;
		}

		//one once per page load 
		this.isSetup = true;
		return true;
	}

	isErrorState() {
		const isErrorState = this._errorCount > this._errorCountMax;
		return isErrorState;
	}

	logError(errorCode) {
		if (errorCode === 'ADS_NO_FILL') {
			return;
		}

		if (errorCode === 'CLIENT_UNSUPPORTED_OPERATION') {
			this._errorCount = this._errorCountMax;
		}

		this._errorCount = (this._errorCount || 0) + 1;
	}

	loadAd(force) {
		console.log('FB_Ads.loadAd');

		if (typeof FBInstant === 'undefined' || !globalThis.FBInstant) {
			console.log('FBInstant plugin not ready'); return false;
		}
		////FBInstant.isGameStarted is a custom attached property, not from facebook.  I am phaseing it out and hoping FBInstant will be ready when needed.
		//  if (!FBInstant.isGameStarted) {
		//     console.log('FBInstant plugin not ready: FBInstant.isGameStarted = false, aborting');
		//     return false;
		// }

		if (!force && this._isAdLoading) {
			console.log('FBInstant.loadAd() - _isAdLoading = true');
			return true;
		}

		if (!force && this._isAdLoaded) {
			console.log('FBInstant.loadAd() - _isAdLoaded = true');
			return true;
		}

		if (!force && this.isErrorState()) {
			console.log('FBInstant.loadAd() - ErrorState = true');
			return true;
		}

		this._isAdLoading = true;

		console.log('FB_Ads.getInterstitialAdAsync start: ' + this.appId);

		try {
			globalThis.FBInstant.getInterstitialAdAsync(
				this.interstitialAdId, // Your Ad Placement Id
			).then((interstitial) => {
				console.log('FB_Ads.getInterstitialAdAsync finished');
				// Load the Ad asynchronously
				this.preloadedInterstitial = interstitial;
				return this.preloadedInterstitial.loadAsync();
			}).then(() => {
				this._isAdLoading = false;
				this._isAdLoaded = true;

				if (this.onAdLoaded) {
					this.onAdLoaded({
						adType: 'interstitial',
					});
				}

				console.log('onAdLoaded: Interstitial preloaded');
			}).catch((err) => {
				this._isAdLoading = false;
				this._isAdLoaded = false;

				this.logError(err.code);

				console.error('InterstitialAd  Error: ' + err.message + ' ' + err.code);
			});
		} catch (ex) {
			console.error('FB_Ads.getInterstitialAdAsync error: ' + ex);
		}
	}

	showAd() {
		console.log('FB_Ads.showAd');

		if (typeof FBInstant === 'undefined' || !globalThis.FBInstant) {
			console.log('FBInstant plugin not ready'); return false;
		}
		////FBInstant.isGameStarted is a custom attached property, not from facebook.  I am phaseing it out and hoping FBInstant will be ready when needed.
		//  if (!FBInstant.isGameStarted) {
		//     console.log('FBInstant plugin not ready: FBInstant.isGameStarted = false, aborting');
		//     return false;
		// }

		if (this.isErrorState()) {
			console.log('FBInstant.showAd() - ErrorState = true');
			return true;
		}

		const isAdLoaded = this._isAdLoaded;

		if (!isAdLoaded) {
			this.loadAd();
		} //note: could change to auto play

		if (isAdLoaded) {
			if (!this.preloadedInterstitial) {
				console.log('FBInstant.showAd() - error: preloadedInterstitial = null');
				return false;
			}

			this.preloadedInterstitial.showAsync()
				.then(() => {
					// Perform post-ad success operation
					console.log('Interstitial ad finished successfully');
					this._isAdLoaded = false;

					if (this.onAdClosed) {
						this.onAdClosed({
							adType: 'interstitial',
						});
					}
				}).catch((err) => {

					this.logError(err.code);
					console.error('interstitialAd  Error: ' + err.message + ' ' + err.code);

				});
		}

	}

	loadAndShowAd() {
		console.log('FB_Ads.showAd');

		if (this.isErrorState()) {
			console.log('FBInstant.showAd() - isErrorState = true');
			return true;
		}

		if (typeof FBInstant === 'undefined' || !globalThis.FBInstant) {
			console.log('FBInstant plugin not ready'); return false;
		}
		////FBInstant.isGameStarted is a custom attached property, not from facebook.  I am phaseing it out and hoping FBInstant will be ready when needed.
		// if (!FBInstant.isGameStarted) {
		//     console.log('FBInstant plugin not ready: FBInstant.isGameStarted = false, aborting');
		//     return false;
		// }

		try {
			globalThis.FBInstant.getInterstitialAdAsync(
				this.interstitialAdId, // Your Ad Placement Id
			).then((interstitial) => {
				console.log('FB_Ads.getInterstitialAdAsync finished');
				// Load the Ad asynchronously
				this.preloadedInterstitial = interstitial;
				return this.preloadedInterstitial.loadAsync();
			}).then(() => {
				if (this.onAdLoaded) {
					this.onAdLoaded({
						adType: 'interstitial',
					});
				}

				console.log('onAdLoaded: Interstitial preloaded');
				return this.preloadedInterstitial.showAsync();
			}).then(() => {
				// Perform post-ad success operation
				console.log('Interstitial ad finished successfully');

				this._isAdLoaded = false;

				if (this.onAdClosed) {
					this.onAdClosed({
						adType: 'interstitial',
					});
				}
			}).catch((err) => {

				this.logError(err.code);
				console.error('InterstitialAd  Error: ' + err.message + ' ' + err.code);

			});

		} catch (ex) {
			console.error('FB_Ads.getInterstitialAdAsync error: ' + ex);
		}
	}

	isAdLoaded() {
		return this._isAdLoaded;
	}

	isRewardedAdLoaded() {
		return this._isRewardedAdLoaded;
	}

	loadRewardedAd(onLoaded) {
		console.log('FB_Ads.loadRewardedAd');

		if (this.isErrorState()) {
			console.log('FBInstant.loadRewardedAd() - isErrorState = true');
			return true;
		}

		if (typeof FBInstant === 'undefined' || !globalThis.FBInstant) {
			console.log('FBInstant plugin not ready'); return false;
		}
		////FBInstant.isGameStarted is a custom attached property, not from facebook.  I am phaseing it out and hoping FBInstant will be ready when needed.
		//  if (!FBInstant.isGameStarted) {
		//     console.log('FBInstant plugin not ready: FBInstant.isGameStarted = false, aborting');
		//     return false;
		// }

		const isAdLoaded = this._isRewardedAdLoaded;

		if (!isAdLoaded) {
			try {
				globalThis.FBInstant.getRewardedVideoAsync(
					this.rewardedAdId, // Your Ad Placement Id
				).then((rewarded) => {
					console.log('FB_Ads.getRewardedVideoAsync finished');
					// Load the Ad asynchronously
					this.preloadedRewardedVideo = rewarded;
					return this.preloadedRewardedVideo.loadAsync();
				}).then(() => {
					if (this.onAdLoaded) {
						this.onAdLoaded({
							adType: 'rewarded',
						});
					}

					console.log('onAdLoaded: Rewarded preloaded');
					this._isRewardedAdLoaded = true;

					if (onLoaded) {
						onLoaded();
					}

				}).catch((err) => {

					this.logError(err.code);
					console.error('loadRewardedAd  Error: ' + err.message + ' ' + err.code);

				});
			} catch (ex) {
				console.error('FB_Ads.getRewardedVideoAsync error: ' + ex);
			}
		}

		if (isAdLoaded) {
			console.log('requestRewardedAd is already loaded');
		}

	}

	showRewardedAd() {
		console.log('FB_Ads.ShowRewardedAd');

		if (this.isErrorState()) {
			console.log('FBInstant.ShowRewardedAd() - isErrorState = true');
			return true;
		}

		if (typeof FBInstant === 'undefined' || !globalThis.FBInstant) {
			console.log('FBInstant plugin not ready'); return false;
		}

		////FBInstant.isGameStarted is a custom attached property, not from facebook.  I am phaseing it out and hoping FBInstant will be ready when needed.
		//  if (!FBInstant.isGameStarted) {
		//     console.log('FBInstant plugin not ready: FBInstant.isGameStarted = false, aborting');
		//     return false;
		// }

		const isAdLoaded = this._isRewardedAdLoaded;

		if (!isAdLoaded) {
			//change to auto play   
			this.loadRewardedAd(() => {
				this.preloadedRewardedVideo.showAsync()
					.then(() => {
						// Perform post-ad success operation
						console.log('Rewarded ad finished successfully');
						this._isRewardedAdLoaded = false;

						if (this.onAdClosed) {
							this.onAdClosed({
								adType: 'rewarded',
								rewardAmount: 150,
							});
						}
					}).catch((err) => {
						this.logError(err.code);
						console.error('RewardedAd  Error: ' + err.message + ' ' + err.code);
					});
			});
		}

		if (isAdLoaded) {
			this.preloadedRewardedVideo.showAsync()
				.then(() => {
					// Perform post-ad success operation
					console.log('Rewarded ad finished successfully');
					this._isRewardedAdLoaded = false;

					if (this.onAdClosed) {
						this.onAdClosed({
							adType: 'rewarded',
							rewardAmount: 150,
						});
					}
				}).catch((err) => {

					if (err && err.code === 'ADS_NO_FILL') { /* squelch */ } else {
						this.logError();
					}

					console.error('RewardedAd  Error: ' + err.message + ' ' + err.code);

				});
		}

	}
}
